export function isSame({ date1, date2 }: { date1?: Date; date2?: Date }): boolean {
	if (!date1 && !date2) return true;
	if (!date1 || !date2) return false;

	// Normalize both dates to the start of the day
	const startOfDay1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
	const startOfDay2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());

	return startOfDay1.getTime() === startOfDay2.getTime();
}
